var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var deduceHeaders = require('../utils/deduceHeaders');

var breathe = require('../utils/breathe'); //Returns the data as a string


function createCSV(_x) {
  return _createCSV.apply(this, arguments);
} //Converts the processed data to csv


function _createCSV() {
  _createCSV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var files, key, device, stream, rows, name, units, headers, sticky, i, s;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            files = {};
            _context.t0 = _regeneratorRuntime.keys(data);

          case 2:
            if ((_context.t1 = _context.t0()).done) {
              _context.next = 17;
              break;
            }

            key = _context.t1.value;
            device = key;
            if (data[key]['device name'] != null) device = data[key]['device name'];

            if (!data[key].streams) {
              _context.next = 15;
              break;
            }

            _context.t2 = _regeneratorRuntime.keys(data[key].streams);

          case 8:
            if ((_context.t3 = _context.t2()).done) {
              _context.next = 15;
              break;
            }

            stream = _context.t3.value;
            _context.next = 12;
            return breathe();

          case 12:
            //We try to save all valid streams
            if (data[key].streams[stream].samples && data[key].streams[stream].samples.length) {
              //Prepare string
              rows = []; //Get name and units to prepare headers

              name = stream;
              if (data[key].streams[stream].name != null) name = data[key].streams[stream].name;
              units = void 0;
              if (data[key].streams[stream].units != null) units = data[key].streams[stream].units;
              headers = deduceHeaders({
                name: name,
                units: units
              });
              sticky = {}; //Loop all the samples

              for (i = 0; i < data[key].streams[stream].samples.length; i++) {
                s = data[key].streams[stream].samples[i]; //Check that at least we have the valid values

                if (s.value != null) {
                  (function () {
                    //Force convert to array
                    if (!Array.isArray(s.value)) s.value = [s.value]; //Update and remember sticky data

                    if (s.sticky) sticky = _objectSpread(_objectSpread({}, sticky), s.sticky); //If first row

                    if (!rows.length) {
                      var firstRow = []; //Add time

                      if (s.cts != null) firstRow.push('cts');
                      if (s.date != null) firstRow.push('date'); //Fill missing headers

                      for (var ii = 0; ii < s.value.length; ii++) {
                        firstRow.push(headers[ii] || ii);
                      } //Add stickies headers


                      firstRow.push.apply(firstRow, _toConsumableArray(Object.keys(sticky))); //Escape commas and add first row

                      rows.push(firstRow.map(function (e) {
                        return "\"".concat(e.toString().replace(/"/g, '""'), "\"");
                      }).join(','));
                    }

                    var row = []; //Add time

                    if (s.cts != null) row.push(s.cts);

                    if (s.date != null) {
                      var processedDate = s.date;
                      if (typeof s.date != 'object') processedDate = new Date(s.date);

                      try {
                        row.push(processedDate.toISOString());
                      } catch (e) {
                        row.push(processedDate);
                      }

                      s.date = processedDate;
                    } //Add all values


                    s.value.forEach(function (v) {
                      if (typeof v === 'number' || typeof v === 'string') row.push(v);else row.push(JSON.stringify(v));
                    }); //Add stickies values

                    for (var _key in sticky) {
                      row.push(sticky[_key]);
                    } //Add line to rows


                    rows.push(row.map(function (e) {
                      return "\"".concat(e.toString().replace(/"/g, '""'), "\"");
                    }).join(','));
                  })();
                }
              } //Join all lines


              files["".concat(device, "-").concat(stream)] = rows.join('\n');
            }

            _context.next = 8;
            break;

          case 15:
            _context.next = 2;
            break;

          case 17:
            return _context.abrupt("return", files);

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _createCSV.apply(this, arguments);
}

module.exports = createCSV;